import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import type { IHttpCall } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  FetchRealPhoneValidationPayloadDTO,
  FetchRealPhoneValidationResponseDTO,
} from './fetch-real-phone-validation.types';

type FetchRealPhoneValidationOptions = {
  httpCall: IHttpCall;
};

export function fetchRealPhoneValidation(
  baseUrl: string,
  payload: FetchRealPhoneValidationPayloadDTO,
  options?: FetchRealPhoneValidationOptions,
): Promise<IHttpResponse<FetchRealPhoneValidationResponseDTO>> {
  const call = options?.httpCall ?? fetchBasedCall;
  const searchParams = new URLSearchParams(payload);

  const request: IHttpRequest<FetchRealPhoneValidationResponseDTO> = {
    url: `${baseUrl}/third-party/api/v1/third-parties/real-phone-validation?${searchParams.toString()}`,
    method: 'GET',
    schemas: {
      request: FetchRealPhoneValidationPayloadDTO,
      response: FetchRealPhoneValidationResponseDTO,
    },
  };

  return call(request);
}
